module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_250000_500000.c12ca506.png";